import { type FC } from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { NavLink } from 'react-router';
import {
  Calculate,
  ChecklistRtl,
  Construction,
  EnergySavingsLeaf,
  Light,
  LocationCity,
  RateReview,
  RollerShades,
  Settings,
  Shower,
} from '@mui/icons-material';

type CommonLinks = {
  auditSettings: string;
};

export type EnergyAuditFormsLinks = {
  background: string;
  mechanical: string;
  lightingType: string;
  lightingCount: string;
  waterFixture: string;
  windows: string;
  checklist: string;
  ecms: string;
  reviewSubmit: string;
};

export type AuditDetailsPageLinks = CommonLinks & {
  energyAudit: EnergyAuditFormsLinks;
};

export type AuditDetailsPageRendererProps = {
  links: AuditDetailsPageLinks;
};

export const AuditDetailsPageRenderer: FC<AuditDetailsPageRendererProps> = ({
  links,
}) => (
  <List sx={{ flexGrow: 1 }}>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.background}>
        <ListItemIcon>
          <LocationCity />
        </ListItemIcon>
        <ListItemText
          primary="Background"
          secondary="General information about the audit"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.windows}>
        <ListItemIcon>
          <RollerShades />
        </ListItemIcon>
        <ListItemText
          primary="Windows"
          secondary="Window dimensions and details"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.waterFixture}>
        <ListItemIcon>
          <Shower />
        </ListItemIcon>
        <ListItemText
          primary="Water Fixtures"
          secondary="Water fixtures and usage details"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.lightingType}>
        <ListItemIcon>
          <Light />
        </ListItemIcon>
        <ListItemText
          primary="Lighting Types"
          secondary="Lighting conditions and setup"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.lightingCount}>
        <ListItemIcon>
          <Calculate />
        </ListItemIcon>
        <ListItemText
          primary="Lighting Count"
          secondary="Count and types of lighting fixtures"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.mechanical}>
        <ListItemIcon>
          <Construction />
        </ListItemIcon>
        <ListItemText
          primary="Mechanical"
          secondary="Mechanical details and specifications"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.ecms}>
        <ListItemIcon>
          <EnergySavingsLeaf />
        </ListItemIcon>
        <ListItemText primary="ECMs" secondary="Energy conservation measures" />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.checklist}>
        <ListItemIcon>
          <ChecklistRtl />
        </ListItemIcon>
        <ListItemText
          primary="Checklist"
          secondary="Check if everything is collected"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.reviewSubmit}>
        <ListItemIcon>
          <RateReview />
        </ListItemIcon>
        <ListItemText
          primary="Review and Submit"
          secondary="Review forms and upload audit data"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.auditSettings}>
        <ListItemIcon>
          <Settings />
        </ListItemIcon>
        <ListItemText
          primary="Settings"
          secondary="Audit configuration and preferences"
        />
      </ListItemButton>
    </ListItem>
  </List>
);
